export default __webpack_public_path__ + "static/media/supportIcon.e03cd74c.png";